import type { GameState, Move } from '@tentactoe/engine';
import type { Theme } from '../theme';
import { MiniBoard } from './MiniBoard';

interface BoardProps {
  readonly state: GameState;
  readonly theme: Theme;
  readonly onPlay: (move: Move) => void;
  readonly locked?: boolean;
}

export function Board({ state, theme, onPlay, locked = false }: BoardProps) {
  return (
    <div className={theme.classes.metaBoard}>
      {state.miniResults.map((_, board) => (
        <MiniBoard
          key={board}
          state={state}
          board={board}
          theme={theme}
          onPlay={onPlay}
          locked={locked}
        />
      ))}
    </div>
  );
}
